import { ArticleCardData } from "@baseComponents/ArticleCard";

export const articleCardAudinorLocalized: {
  [locale: string]: ArticleCardData;
} = {
  en: {
    area: "embedded",
    image: {
      src: "/portfolio_embedded/audinor/main_img.png",
      alt: "Student listening to a lecture using a device supporting hard of hearing children with BLE Audio",
    },
    title: "BLE Audio for better learning access",
    description:
      "We supported Audinor, a company developing innovative hearing aid technologies, in building a BLE Audio device for hard of hearing children. The solution helps improve classroom communication and equal access to education in schools and kindergartens through cutting-edge wireless audio transmission.",
    date: new Date("2024-06-22"),
    timeToRead: 7,
    href: "/portfolio/audinor",
  },
  pl: {
    area: "embedded",
    image: {
      src: "/portfolio_embedded/audinor/main_img.png",
      alt: "Student słuchający wykładu z użyciem urządzenia wspomagającego niedosłyszące dzieci z BLE Audio",
    },
    title: "BLE Audio dla lepszego dostępu do nauki",
    description:
      "Wspieraliśmy firmę Audinor, tworzącą innowacyjne technologie wspomagające słyszenie, w budowie urządzenia BLE Audio dla dzieci z ubytkiem słuchu. Rozwiązanie poprawia komunikację w klasie i zapewnia równy dostęp do edukacji w szkołach i przedszkolach dzięki nowoczesnej transmisji dźwięku.",
    date: new Date("2024-06-22"),
    timeToRead: 7,
    href: "/portfolio/audinor",
  },
};
